var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.866 0H20.134C20.701 0 21.445 0.369 21.794 0.824L24.066 4.174C24.288 4.5 24.657 4.698 25.051 4.698H29.937C31.077 4.698 31.999 5.628 31.999 6.781V21.917C31.999 23.068 31.077 24.001 29.937 24.001H2.063C0.923 24.001 0 23.07 0 21.917V6.781C0 5.63 0.923 4.698 2.063 4.698H6.969C7.35 4.698 7.707 4.508 7.923 4.192L10.205 0.824C10.555 0.37 11.302 0 11.866 0ZM23.742 7.306C23.742 7.882 24.204 8.349 24.774 8.349C25.345 8.349 25.806 7.882 25.806 7.306C25.806 6.73 25.345 6.262 24.774 6.262C24.204 6.262 23.742 6.73 23.742 7.306ZM8.774 14.088C8.774 18.122 12.009 21.392 16 21.392C19.991 21.392 23.225 18.122 23.225 14.088C23.225 10.053 19.991 6.784 16 6.784C12.009 6.784 8.774 10.053 8.774 14.088ZM3.096 1.044H5.162C5.732 1.044 6.193 1.508 6.193 2.088V3.131H2.064V2.088C2.064 1.511 2.523 1.044 3.096 1.044ZM10.323 14.088C10.323 10.917 12.864 8.349 16 8.349C19.136 8.349 21.677 10.917 21.677 14.088C21.677 17.258 19.136 19.827 16 19.827C12.864 19.827 10.323 17.258 10.323 14.088Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.f4ed62a7.svg";
export { ForwardRef as ReactComponent };